import {validateEmail, validateFieldLength} from '../../../utility/validationUtil';
import {questionFor} from '../Profiles/ProfileTabs/ContactsAndEthniicityTab/addContactRules';

// Maria, 19 October 2026: a staff version of the student Add Contact box. The fields, checks and messages are the
// same as the old Add Contact form on the staff profile; only the layout changes, one question at a time.

export const STAFF_CONTACT_STEPS = ['who', 'contact', 'check'];

export const emptyStaffContact = () => ({forename: '', surname: '', typeCode: '', email: '', phone: ''});

export const staffContactFrom = existing => ({
    forename: existing?.forename ?? '',
    surname: existing?.surname ?? '',
    typeCode: existing?.typeCode ?? '',
    email: existing?.email ?? '',
    phone: existing?.phone ?? ''
});

const nameCheck = (value, label) => {
    if (!value || value.trim() === '') return `${label} is required`;
    if (value.length > 60) return `${label} cannot exceed 60 characters`;
    return '';
};

// The message under each box, or '' when the answer can be saved. An optional box is checked only once something
// has been typed in it, as before.
export const staffContactErrors = contact => ({
    forename: nameCheck(contact.forename, 'Forename'),
    surname: nameCheck(contact.surname, 'Surname'),
    email: contact.email ? validateEmail(contact.email).message : '',
    phone: contact.phone ? validateFieldLength(contact.phone, 20).message : ''
});

export const canGoOnStaff = (step, contact) => {
    const errors = staffContactErrors(contact);
    if (step === 'who') return !errors.forename && !errors.surname;
    if (step === 'contact') return !errors.email && !errors.phone;
    return true;
};

// The same headings as the student Add Contact box (Maria, 18 October 2026). A staff contact has no home address,
// so the second page is 'Contact Details' without it.
export const staffQuestionFor = (step, contact) => ({
    who: 'Contact Details',
    contact: 'Contact Details',
    check: questionFor('check', contact)
}[step]);

// The same values the old form saved: a type left empty is saved as no type.
export const staffContactPayload = contact => ({
    forename: contact.forename,
    surname: contact.surname,
    typeCode: contact.typeCode === '' ? null : contact.typeCode,
    email: contact.email,
    phone: contact.phone
});
